<template>
  <div class="fam-hero" :class="{ 'fam-hero-lg': large }">
    <div class="fam-hero-bg"></div>
    <div class="fam-hero-content">
      <div class="fam-hero-title">{{ title }}</div>
      <div v-if="sub" class="fam-hero-sub">{{ sub }}</div>
    </div>
  </div>
</template>

<script>
// 家族模块统一渐变头部（纯 CSS 实现，不依赖图片资源）
export default {
  name: "FamilyHero",
  props: {
    title: { type: String, default: "" },
    sub: { type: String, default: "" },
    // 内容区为悬浮白卡时开启，留出被压住的空间
    large: { type: Boolean, default: false },
  },
};
</script>
